import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import cs from "./cs.json";
import en from "./en.json";

export const SUPPORTED_LANGUAGES = [
  { code: "cs", label: "Čeština", flag: "🇨🇿" },
  { code: "en", label: "English", flag: "🇬🇧" },
] as const;

export type LangCode = (typeof SUPPORTED_LANGUAGES)[number]["code"];

function resolveLang(lng: string): LangCode {
  const base = lng.split("-")[0].toLowerCase();
  const found = SUPPORTED_LANGUAGES.find((l) => l.code === base);
  return found ? (found.code as LangCode) : "cs";
}

export { resolveLang };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      cs: { translation: cs },
      en: { translation: en },
    },
    fallbackLng: "cs",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "lang",
      caches: ["localStorage"],
      convertDetectedLanguage: resolveLang,
    },
  });

export default i18n;
